import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import styles from './SaleBanner.module.scss';

interface ISaleBannerProps {
  className?: string;
  backgroundColor?: string;
  product: any;
}

const SaleBanner = ({
  className = '',
  backgroundColor,
  product
}: ISaleBannerProps) => {
  const theme = useTheme();
  const { saleOnSalePrice, totalDiscountPercent } = product;

  if (!saleOnSalePrice && !totalDiscountPercent) return null;

  const getText = () => {
    if (saleOnSalePrice) return `${Math.round(saleOnSalePrice.percentage)}% OFF`;
    if (totalDiscountPercent) return `${Math.round(totalDiscountPercent)}% OFF`;
    return '';
  };

  return (
    <div
      className={classNames(className, styles.Sale, theme.styles.Overline)}
      style={{
        color: theme.colors.core2,
        backgroundColor: backgroundColor ?? theme.colors.core4
      }}
    >
      { getText() }
    </div>
  );
};

export default SaleBanner;
